// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from "@rails/ujs";
import * as ActiveStorage from "@rails/activestorage";
import createConsumer from "@rails/actioncable";


import $ from "jquery";
window.jQuery = $;
window.$ = $;

// jqury-bottom-1.0.js等の処理でpostした時にcsrfトークンの処理が出たので、追加 
$.ajaxSetup({
  headers: {
    'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
  }
});


Rails.start()
ActiveStorage.start()